import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Button } from '@atlas/ui';
import { login, isAuthBypassed } from '../../lib/auth';

export function LoginPage() {
  const navigate = useNavigate();
  const [passphrase, setPassphrase] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (login(passphrase)) {
      navigate({ to: '/command' });
      return;
    }
    setError('Enter your observatory passphrase.');
  };

  return (
    <div className="login-scene">
      <div className="login-topography" aria-hidden="true" />
      <div className="login-grid" aria-hidden="true" />

      <main className="login-panel">
        <header className="login-header">
          <span className="login-eyebrow">Obsidian Cartography</span>
          <h1>Cold State Atlas</h1>
          <p className="login-tagline">Map the game. Price the structure. Move the capital.</p>
        </header>

        <form className="login-form" onSubmit={handleSubmit}>
          <label htmlFor="passphrase" className="login-label">
            Observatory passphrase
          </label>
          <input
            id="passphrase"
            type="password"
            autoComplete="current-password"
            value={passphrase}
            onChange={(e) => {
              setPassphrase(e.target.value);
              setError('');
            }}
            className="login-input"
            placeholder="Enter passphrase"
          />
          {error && (
            <p className="login-error" role="alert">
              {error}
            </p>
          )}
          <Button type="submit" variant="primary" className="login-submit">
            Enter observatory
          </Button>
        </form>

        {isAuthBypassed() && (
          <p className="login-bypass" role="status">
            Dev bypass active — any passphrase grants access. No live portfolio data is loaded.
          </p>
        )}

        <footer className="login-footer">
          <span>Private strategic observatory</span>
          <span>Fixture environment · v0.1</span>
        </footer>
      </main>
    </div>
  );
}
